import React from 'react';
import { Heading } from '@chakra-ui/react';
import { MainLayout } from '@src/components/layouts/MainLayout';

export const Error = ({ error }: { error: any }) => (
  <MainLayout>
    <Heading> Error has occured + {error.message} </Heading>
  </MainLayout>
);
